const ACRONYMS: Record<string, string> = {
  roi: "ROI",
  faq: "FAQ",
  toc: "TOC",
  qr: "QR",
};

const UNKNOWN_MODULE_TYPE_LABEL = "Unknown";

export function getModuleTypeLabel(type?: string | null): string {
  if (!type) return UNKNOWN_MODULE_TYPE_LABEL;

  const words = type.trim().split(/[-_\s]+/).filter(Boolean);
  if (words.length === 0) return UNKNOWN_MODULE_TYPE_LABEL;

  return words
    .map((word) => {
      const acronym = ACRONYMS[word.toLowerCase()];
      if (acronym) return acronym;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}
